import supabaseClient from '@/api/supabaseClient.ts';
import { LessonRepository as SharedLessonRepository } from '$/repositories/lessonRepository/LessonRepository.ts';

const lessonRepository = new SharedLessonRepository(supabaseClient);
export default lessonRepository;


